import { Cookie } from 'lucide-react';
import LegalPage from '../components/LegalPage';

const sections = [
  {
    id: 'what-is-a-cookie',
    title: '1. What Is a Cookie?',
    body: (
      <p>
        A cookie is a small piece of data stored in your browser when you
        visit a website. Cookies let a site remember you between visits,
        maintain your login session, and measure how its features are used.
      </p>
    ),
  },
  {
    id: 'what-we-use',
    title: '2. What RoomHora Uses',
    body: (
      <>
        <p>We use the following categories of cookies and local storage:</p>
        <ul className="list-disc pl-5 space-y-3">
          <li>
            <strong>Essential (always on).</strong> Session tokens, CSRF
            protection, login state, currency preference. Without these the
            site cannot function.
          </li>
          <li>
            <strong>Preferences.</strong> Your theme choice, recent searches,
            saved favorites, and cookie consent status.
          </li>
          <li>
            <strong>Analytics (optional).</strong> Anonymized usage
            statistics to help us understand which features are working. We
            only load these if you accept the cookie banner.
          </li>
          <li>
            <strong>Error monitoring (optional).</strong> If we detect a
            crash, we send a redacted error report to our engineering team
            so we can fix it.
          </li>
        </ul>
        <p>
          We do <strong>not</strong> use advertising cookies or share data
          with ad networks.
        </p>
      </>
    ),
  },
  {
    id: 'controls',
    title: '3. Your Controls',
    body: (
      <>
        <p>You can:</p>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            Change your cookie preferences from the footer at any time
            (&ldquo;Cookie settings&rdquo;).
          </li>
          <li>
            Clear cookies in your browser&rsquo;s privacy settings — note
            that you&rsquo;ll be logged out and your preferences reset.
          </li>
          <li>
            Use your browser&rsquo;s Do Not Track signal; we honor it for
            non-essential cookies.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 'third-parties',
    title: '4. Third-Party Services',
    body: (
      <>
        <p>
          Some features depend on third-party services that may set their own
          cookies. These include:
        </p>
        <ul className="list-disc pl-5 space-y-2">
          <li>
            Map tiles (for property location display).
          </li>
          <li>Payment processing (if you make a booking).</li>
          <li>Authentication providers (Google Sign-In, if you use it).</li>
        </ul>
        <p>
          Each provider has its own privacy policy, which we encourage you to
          review.
        </p>
      </>
    ),
  },
  {
    id: 'contact',
    title: '5. Contact',
    body: (
      <p>
        Questions?{' '}
        <a href="mailto:privacy@roomhora.com" className="text-accent hover:underline">
          privacy@roomhora.com
        </a>
      </p>
    ),
  },
];

export default function Cookies() {
  return (
    <LegalPage
      icon={Cookie}
      eyebrow="Cookies"
      title="Cookie Policy"
      effectiveDate="April 22, 2026"
      summary="A plain-English explanation of how RoomHora uses cookies — what's essential, what's optional, and how to control them."
      sections={sections}
    />
  );
}
